import { Injectable, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { QarepaStorageUtilsService } from '@qarepa/common';
import { Menu } from '../types/menu';

@Injectable({
  providedIn: 'root',
})
export class DashboardStorageService {
  private storageUtilsService = inject(QarepaStorageUtilsService);

  private menu: Menu;
  protected readonly menuSubject = new Subject<Menu>();

  private lsKey = 'menu';

  public get(): Menu {
    if (this.storageUtilsService.validateInLocalStorage(this.lsKey)) {
      return JSON.parse(localStorage.getItem(this.lsKey));
    } else {
      return this.menu;
    }
  }

  public get$(): Observable<Menu> {
    return this.menuSubject.asObservable();
  }

  public set(menu: Menu): void {
    if (this.storageUtilsService.validateLocalStorage()) {
      localStorage.setItem(this.lsKey, JSON.stringify(menu));
    } else {
      this.menu = menu;
    }
    this.menuSubject.next(menu);
  }

  public reset(): void {
    if (this.storageUtilsService.validateInLocalStorage(this.lsKey)) {
      localStorage.removeItem(this.lsKey);
    } else {
      this.menu = undefined;
    }
    this.menuSubject.next(null);
  }

  get hasMenu(): boolean {
    if (
      typeof this.get()?.isActiveEmployeeMenu === 'boolean' &&
      this.get().isActiveEmployeeMenu !== null
    ) {
      return true;
    }
    return false;
  }
}
